import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import {
  Button,
  CardServicesHighlight,
  CardServicesHighlightProps,
  Carousel,
  Title,
} from '@plataformaxvia/design-system';
import { Container } from '../../components/container/container';
import { RelevantServiceWrap } from './style';
import styles from './style.module.css';

export interface RelevantServicesProps {
  services?: CardServicesHighlightProps[];
  isMobile?: boolean;
}

export const RelevantServices: FC<RelevantServicesProps> = ({
  services,
  isMobile,
}) => {
  const history = useHistory();

  return (
    <RelevantServiceWrap isMediumScreen={isMobile}>
      <Container
        className="RelevantServiceWrap"
        style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Title
            title={isMobile ? 'Em destaque' : 'Serviços em destaque'}
            as='h2'
          />
          <Button
            variant="primary"
            onClick={() => history.push('/carta-de-servicos')}
            label="Mais serviços"
            iconEnd={<ArrowForwardIcon fontSize="small" />}
            style={{ whiteSpace: 'nowrap' }}
            aria-label="Mais serviços"
          />
        </div>
        <div style={{ display: 'grid' }}>
          <Carousel>
            <Carousel.Body>
              {!isMobile && (
                <Carousel.Previous>
                  <button className={styles.arrow} aria-label="Anterior">
                    <ArrowBackIcon />
                  </button>
                </Carousel.Previous>
              )}
              <Carousel.Content autoFlow="column" gapX={32} overflowOffset={20}>
                {services?.map((service, index) => (
                  <Carousel.Item key={index}>
                    <CardServicesHighlight
                      key={index}
                      info={service?.info ?? ''}
                      title={service.title}
                      imageUrl={service?.imageUrl}
                      onClick={service.onClick}
                    />
                  </Carousel.Item>
                ))}
              </Carousel.Content>
              {!isMobile && (
                <Carousel.Next>
                  <button className={styles.arrow} aria-label="Próximo">
                    <ArrowForwardIcon />
                  </button>
                </Carousel.Next>
              )}
            </Carousel.Body>
            <Carousel.Pagination style={{ marginTop: 4 }} />
          </Carousel>
        </div>
      </Container>
    </RelevantServiceWrap>
  );
};
